<ng-container *ngIf="(product$ | async)">
  <!-- <div class="product__header">
    <div class="w-full mx-auto max-w-screen-xl px-14">
      <h1 class="product__header--name h2">{{product.name}}</h1>
      <div class="product__header--row mt-3">
        <div class="product__header--info">

          <div class="product__header--info--item mr-6">
            <span class="product__header--info--item--label">{{'Year' | transloco}}</span>
            <span class="product__header--info--item--value">{{product.year}}</span>
          </div>

          <div class="product__header--info--item">
            <span class="product__header--info--item--label">{{'value' | transloco}}</span>
            <span class="product__header--info--item--value">
              <ng-container *ngIf="!product.price">{{'Sob Consulta' | transloco}}</ng-container>
              <ng-container *ngIf="product.price">{{product.price | currency:'EUR'}}</ng-container>
            </span>
          </div>

        </div>
        <div class="product__header--stats">b</div>
      </div>
    </div>
  </div> -->

  <section id="product-header" class="bg-[#fafafa] pt-8 pb-14">
    <div class="w-full mx-auto max-w-screen-xl px-4 md:px-14 grid grid-cols-12 gap-x-6 gap-y-3">
      <h1 id="product-name" class="h3 md:h2 col-span-12">{{ product.name }}</h1>

      <div class="col-span-12">
        <div class="grid grid-cols-2 gap-0">
          <div class="left-side flex gap-x-3 md:gap-x-6">
            <div class="product-top-attr col-span-1">
              <span class="product-top-attr--label">{{ "Year" | transloco }}</span>
              <span class="product-top-attr--value">{{ product.year }}</span>
            </div>

            <div class="product-top-attr col-span-3">
              <span class="product-top-attr--label">{{ "Value" | transloco }}</span>
              <span class="product-top-attr--value">
                <ng-container *ngIf="!product.price">{{
                  "Sob Consulta" | transloco
                  }}</ng-container>
                <ng-container *ngIf="product.price">{{
                  product.price | currency: "EUR"
                  }}</ng-container>
              </span>
            </div>
          </div>
          <div class="right-side flex gap-x-3 md:gap-x-6 justify-end">
            <div class="product-top-attr col-span-1 col-start-11 flex items-center justify-end">
              <span class="product-top-attr--label">
                <mat-icon svgIcon="heroicons_outline:bookmark"></mat-icon>
              </span>
              <span class="product-top-attr--value">{{
                product.numberMessages
                }}</span>
            </div>

            <div class="product-top-attr col-span-1 col-start-12 flex items-center justify-end">
              <span class="product-top-attr--label">
                <mat-icon svgIcon="heroicons_outline:eye"></mat-icon>
              </span>
              <span class="product-top-attr--value">{{ product.numberViews }}</span>
            </div>
          </div>
        </div>
      </div>



    </div>

    <div id="product-gallery" class="w-full mx-auto max-w-screen-xl px-4 md:px-14 grid grid-cols-12 gap-0 mt-4">
      <div class="col-span-12 md:col-span-8 h-[211px] md:h-[568px]">
        <Image [src]="getImageUrl(product.images.data[0], 'large')"
          [bigSrc]="getImageUrl(product.images.data[0], 'large')" class="w-full h-full">
        </Image>
      </div>
      <div class="col-span-12 mt-2 md:mt-0 md:col-span-4 ">
        <div class="grid grid-cols-2 gap-1 md:ml-1">
          <div class="col-span-1 h-[139px]" *ngFor="let item of product.images.data.slice(1, 9)">
            <Image [src]="getImageUrl(item, 'thumbnail')" [bigSrc]="getImageUrl(item, 'large')" class="w-full h-full">
            </Image>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section id="product-content"
    class="w-full mx-auto max-w-screen-xl px-0 md:px-14 grid grid-cols-12 gap-1 mt-4 md:mt-14">
    <div id="product-description" class="col-span-12 order-2 px-4 md:px-0 md:order-1 md:col-span-8 product-description"
      [innerHTML]="product?.description"></div>

    <div id="product-attributes-actions" class="col-span-12 order-1 md:col-span-4 md:order-2">
      <div id="product-attributes" class="bg-[#FAFAFA] mb-4 p-8 grid grid-cols-2 gap-0">
        <ng-container *ngFor="
            let item of product.attributes;
            let i = index;
            let last = last
          ">
          <div class="product-attribute flex flex-col col-span-1 mb-6">
            <label class="product-attribute--label">{{
              item?.attribute?.data?.attributes?.friendlyName
              }}</label>
            <span class="product-attribute--value">
              <ng-container *ngIf="item?.customValue">
                {{ item?.customValue }}
                <ng-container *ngIf="validCustomSuffix(item?.attribute?.data?.attributes?.name)">
                  {{ item?.attribute?.data?.attributes?.name }}
                </ng-container>
              </ng-container>

              <ng-container *ngIf="!item.customValue && item.attribute_value.data">
                {{ item?.attribute_value?.data?.attributes?.value }}
              </ng-container>
            </span>
          </div>

          <hr class="w-full col-span-2 bg-[#F0F0F0] mt-0 mb-6" *ngIf="i >= 3 && (i + 1) % 4 === 0 && !last" />
        </ng-container>

        <div class="product-attribute flex flex-col col-span-1">
          <label class="product-attribute--label">{{
            "Category" | transloco
            }}</label>
          <span class="product-attribute--value">{{
            product?.product_category?.data?.attributes?.name
            }}</span>
        </div>

        <hr class="w-full col-span-2 bg-[#F0F0F0] mt-0 mb-6" />

        <div class="product-attribute flex flex-col col-span-1">
          <label class="product-attribute--label">{{
            "Status" | transloco
            }}</label>
          <span class="product-attribute--value">{{
            product?.product_condition?.data?.attributes?.name
            }}</span>
        </div>

        <div class="product-attribute flex flex-col col-span-1">
          <label class="product-attribute--label">{{
            "Location" | transloco
            }}</label>
          <span class="product-attribute--value">
            {{ product?.city?.data?.attributes?.name }},
            {{ product?.country }}
          </span>
        </div>

        <a mat-button routerLink="." fragment="contact-seller"
          class="bg-red-motorbest-600 col-span-2 rounded-none text-white text-base font-semibold min-h-13 mt-6">
          {{'View seller contacts' | transloco}}
        </a>
      </div>

      <div id="product-attributes" class="bg-[#FAFAFA] mb-4 p-8 grid grid-cols-2 gap-0" *ngIf="false">
        <div class="col-span-2 text-xl text-[#15151E] font-medium mb-4">
          Mantenha-se informado
        </div>
        <div class="col-span-2 text-md text-[#575757] font-normal mb-6">
          Receba todas as notícias sobre oportunidades semelhantes
        </div>
        <button mat-button
          class="bg-[#15151E] col-span-2 rounded-none text-white text-base font-semibold min-h-13 mt-6">
          Subscrever newsletter
        </button>
      </div>
    </div>
  </section>

  <section id="gallery" class="w-full mx-auto max-w-screen-xl px-4 mt-4  md:px-14 md:mt-14"
    *ngIf="product.images.data.slice(9).length">
    <h5>{{ "Other Images" | transloco }}</h5>
    <div class="grid grid-cols-2  md:grid-cols-6 gap-2 mt-4">
      <div class="col-span-1 h-[135px]" *ngFor="let item of product.images.data.slice(9)">
        <Image [src]="getImageUrl(item,'thumbnail')" [bigSrc]="getImageUrl(item, 'large')" class="w-full h-full">
        </Image>
      </div>
    </div>
    <div class="flex justify-center mt-10 mb-16">
      <button mat-stroked-button color="primary" *ngIf="false"
        class="w-full max-w-[223px] rounded-none text-red-motorbest-600 border-red-motorbest-600 border-solid text-base font-semibold min-h-13">
        Ver mais fotografias
      </button>
    </div>
  </section>

  <app-seller-contact-form id="contact-seller" [product]="product" [seller]="product.seller"></app-seller-contact-form>
</ng-container>